import React, {useEffect, useContext} from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import ProductItem from "./ProductItem";
import { getFavoriteProductsParent } from "../http/productAPI";




const FavoriteProducts = observer(() => {
    const { product } = useContext(Context);        
    const handleClose = () => console.log(0);

    useEffect(() => {
             getFavoriteProductsParent(product.selectedFolder.id, product).then(data => {
                const allFavorites = data.flatMap(item => item.favoriteProducts); // 🧠 flatten всех продуктов
                product.setProducts(allFavorites); // 🗃️ сохраняем как обычный список продуктов
              });
          }, [product.selectedFolder])
 
             
          return (
            <>
            {product.products && product.products.length > 0 ? (
               product.products.map((product, index) => (
               <React.Fragment key={product.id}>
               <ProductItem 
                   productItem={product} 
                   handleClose={handleClose}                   
               />               
           </React.Fragment>
       ))) : (
        <p>Продукты не найдены</p>
    )}
    </>
    );
    });
    
    export default FavoriteProducts;